export enum WREX_LINK {
    /**
     * @value Insert link
     * @description text editor insert link button tooltip
     */
    LINK_BUTTON_TOOLTIP = 'FRONT.TEXT_EDITOR.FORMAT.LINK_BUTTON',
    /**
     * @value Link (%SHORTCUT%)
     * @description The label of the button to insert a link in the rich text.
     */
    LINK_BUTTON_WITH_SHORTCUT = 'WREX_LINK.LINK_BUTTON_WITH_SHORTCUT',
    /**
     * @value Link label
     */
    LINK_LABEL = 'COMMUNITY_POST_LINK_LABEL',
    /**
     * @value Remove link
     * @description Label used on a button used to remove a link (convert a link text to a normal text)
     */
    LINK_REMOVE = 'COMMUNITY_POST_LINK_REMOVE',
    /**
     * @value Link url
     */
    LINK_URL = 'COMMUNITY_POST_LINK_URL',
    /**
     * @value Link unavailable
     * @description The message displayed in a tooltip on unavailable links in rich content (posts, articles, events ..).
     */
    UNAVAILABLE_LINK = 'TEXT_EDITOR.UNAVAILABLE_LINK',
}
